export function conversationThreadPin(row = {}) {
  const metadata = row.metadata && typeof row.metadata === 'object' ? row.metadata : {}
  return {
    pinned: Boolean(metadata.pinned),
    pinnedAt: metadata.pinned_at ?? null,
  }
}
